import { propOr } from 'ramda';
import { useBonusesStore } from '../../store';

const selectAllTypesBonuses = () => propOr({}, 'allTypesBonuses');
const selectAllTypesBonusesHistory = () => propOr({}, 'allTypesBonusesHistory');

export const useAllTypesBonuses = () => {
  const allTypesBonuses = useBonusesStore(selectAllTypesBonuses());
  const allTypesBonusesHistory = useBonusesStore(
    selectAllTypesBonusesHistory()
  );
  const { data: allTypesBonusesData } = allTypesBonuses;
  const { data: allTypesBonusesHistoryData } = allTypesBonusesHistory;

  return { ...allTypesBonusesData, ...allTypesBonusesHistoryData };
};
